module.exports = __webpack_public_path__ + "static/ozsAdventuresLogoSmall-20e533f18e7dc97a53dec860124adaca.png";